<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                @if (reactiveForm) {
                    <app-reactive-form-builder
                        #builderRef
                        (formChanges)="reactiveFormChanges($event[0], $event[1])"
                        (goBack)="goBack()"
                        [form]="reactiveForm.formFields"
                        [dropdownLoadTrigger]="dropdownLoadTrigger"
                        [id]="getRegisterId()"
                        [dropdownsFinalized]="dropdownsFinalized"
                        [request]="request"
                        [getRequest]="visitasApi.visitasPereira.GET">
                    </app-reactive-form-builder>
                }
            </div>
        </div>
    </div>
</p-panel>
